const footerLinks = {
  services: [
    { label: "ジェルネイル", href: "#services" },
    { label: "アートネイル", href: "#services" },
    { label: "ハンドケア", href: "#services" },
    { label: "フットスパ", href: "#services" },
  ],
  gallery: [
    { label: "施術例ギャラリー", href: "#gallery" },
    { label: "季節限定デザイン", href: "#gallery" },
    { label: "トレンドコレクション", href: "#gallery" },
  ],
  booking: [
    { label: "オンライン予約", href: "#booking" },
    { label: "ご予約について", href: "#booking" },
    { label: "キャンセルポリシー", href: "#contact" },
  ],
  info: [
    { label: "サロンについて", href: "#about" },
    { label: "アクセス", href: "#contact" },
    { label: "お問い合わせ", href: "#contact" },
  ],
};

const handleNavClick = (href: string) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Footer() {
  return (
    <footer className="bg-[#F5F0EB] border-t border-[#E8E4DF]">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="https://public.readdy.ai/ai/img_res/a99c583f-c7d6-4743-b56e-d3f6a869d545.png"
                alt="Atelier NANA"
                className="h-12 w-12 object-contain rounded-full"
              />
              <span className="font-['Cormorant_Garamond'] text-2xl font-semibold text-[#1A1A1A] tracking-widest">
                Atelier NANA
              </span>
            </div>
            <p className="font-['Noto_Sans_JP'] text-sm text-[#7A6E68] leading-relaxed mb-6">
              トレンドを取り入れたネイルデザインを提供する<br />
              東京のネイルサロン。丁寧なカウンセリングから<br />
              あなただけのオリジナルデザインをお届けします。
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://instagram.com"
                rel="nofollow noopener noreferrer"
                target="_blank"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-[#E8E4DF] text-[#3D2E2A] hover:bg-[#C9A87C] hover:text-white transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-base"></i>
              </a>
              <a
                href="https://twitter.com"
                rel="nofollow noopener noreferrer"
                target="_blank"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-[#E8E4DF] text-[#3D2E2A] hover:bg-[#C9A87C] hover:text-white transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-twitter-x-line text-base"></i>
              </a>
              <a
                href="https://line.me"
                rel="nofollow noopener noreferrer"
                target="_blank"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-[#E8E4DF] text-[#3D2E2A] hover:bg-[#C9A87C] hover:text-white transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-line-fill text-base"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-['DM_Sans'] text-xs font-semibold tracking-[0.2em] uppercase text-[#1A1A1A] mb-4">
              <a href="#services" onClick={(e) => { e.preventDefault(); handleNavClick("#services"); }}>Services</a>
            </h4>
            <div className="h-px bg-[#D8D2CB] mb-4"></div>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                    className="font-['Noto_Sans_JP'] text-sm text-[#7A6E68] hover:text-[#C9A87C] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Gallery */}
          <div>
            <h4 className="font-['DM_Sans'] text-xs font-semibold tracking-[0.2em] uppercase text-[#1A1A1A] mb-4">
              <a href="#gallery" onClick={(e) => { e.preventDefault(); handleNavClick("#gallery"); }}>Gallery</a>
            </h4>
            <div className="h-px bg-[#D8D2CB] mb-4"></div>
            <ul className="space-y-3">
              {footerLinks.gallery.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                    className="font-['Noto_Sans_JP'] text-sm text-[#7A6E68] hover:text-[#C9A87C] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>

            <h4 className="font-['DM_Sans'] text-xs font-semibold tracking-[0.2em] uppercase text-[#1A1A1A] mb-4 mt-8">
              <a href="#booking" onClick={(e) => { e.preventDefault(); handleNavClick("#booking"); }}>Booking</a>
            </h4>
            <div className="h-px bg-[#D8D2CB] mb-4"></div>
            <ul className="space-y-3">
              {footerLinks.booking.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                    className="font-['Noto_Sans_JP'] text-sm text-[#7A6E68] hover:text-[#C9A87C] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 className="font-['DM_Sans'] text-xs font-semibold tracking-[0.2em] uppercase text-[#1A1A1A] mb-4">
              <a href="#about" onClick={(e) => { e.preventDefault(); handleNavClick("#about"); }}>Salon Info</a>
            </h4>
            <div className="h-px bg-[#D8D2CB] mb-4"></div>
            <ul className="space-y-3 mb-6">
              {footerLinks.info.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                    className="font-['Noto_Sans_JP'] text-sm text-[#7A6E68] hover:text-[#C9A87C] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="bg-white rounded-lg p-4">
              <p className="font-['Noto_Sans_JP'] text-xs text-[#7A6E68] leading-relaxed">
                <strong className="text-[#3D2E2A]">営業時間</strong><br />
                月〜土 10:00 — 20:00<br />
                日・祝 10:00 — 18:00<br />
                <span className="text-[#C9A87C]">水曜定休</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#DDD7CF] bg-[#EDE8E3]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-['DM_Sans'] text-xs text-[#9E9189]">
            © 2026 Atelier NANA. All rights reserved.
          </p>
          <p className="font-['Noto_Sans_JP'] text-xs text-[#9E9189]">
            東京都渋谷区神宮前 3-5-12
          </p>
        </div>
      </div>
    </footer>
  );
}
